import Dashboard from "@/common/components/layout/Dashboard";
import Toast from "@/common/components/ui/toast";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import TableInfractionTickets from "./components/table/TableInfractionTickets";

function InfractionTicketsPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableInfractionTickets />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}

export default InfractionTicketsPage;
